<template>
  <div class="my-5">
    <div class="mb-5 pl-4"><strong>{{ satisfactionDetail.orders }}. {{ satisfactionDetail.title }}</strong></div>
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <GChart
          v-if="!Array.isArray(satisfactionDetail.values)"
          type="BarChart"
          :settings="{packages: ['corechart','bar']}"
          :data="chartData"
          :options="chartOptions"
          @ready="printedSatisfactionCharts"
        />
        <div v-else class="text-muted text-center py-4">
          ยังไม่มีผู้ตอบแบบสอบถาม
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart
  },
  props: {
    satisfactionDetail: { type: Object, required: true }
  },
  data () {
    return {
      chartLib: null,
      chartOptions: {
        bars: 'horizontal',
        height: 200,
        width: 800
      }
    }
  },
  computed: {
    chartData () {
      let data = [
        ['', 'คำตอบ']
      ]
      Object.keys(this.satisfactionDetail.values).forEach(key => {
        data.push([
          key,
          this.satisfactionDetail.values[key]
        ])
      })
      return data
    },
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) }
  },
  methods: {
    printedSatisfactionCharts (chart, google) {
      google.visualization.events.addListener(chart, 'ready', () => {
        if (this.project.printedSatisfactionCharts === null) {
          let data = {
            title: this.satisfactionDetail.title,
            orders: this.satisfactionDetail.orders,
            image: chart.getImageURI()
          }
          this.$emit('printed', data)
        }
      })
    }
  }
}

</script>
